/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaStockOutboundOrderStatisticsVo
 */
export interface KoreaStockOutboundOrderStatisticsVo {
    /**
     * 总订单数
     * @type {number}
     * @memberof KoreaStockOutboundOrderStatisticsVo
     */
    totalOrderCount?: number;
    /**
     * 处理中单数
     * @type {number}
     * @memberof KoreaStockOutboundOrderStatisticsVo
     */
    totalProcessingOrderCount?: number;
    /**
     * 已出库单数
     * @type {number}
     * @memberof KoreaStockOutboundOrderStatisticsVo
     */
    totalOutboundOrderCount?: number;
    /**
     * 出库取消单数
     * @type {number}
     * @memberof KoreaStockOutboundOrderStatisticsVo
     */
    totalOutboundCancelOrderCount?: number;
    /**
     * 原运单退货单数
     * @type {number}
     * @memberof KoreaStockOutboundOrderStatisticsVo
     */
    totalReturnOrderCount?: number;
}

/**
 * Check if a given object implements the KoreaStockOutboundOrderStatisticsVo interface.
 */
export function instanceOfKoreaStockOutboundOrderStatisticsVo(value: object): value is KoreaStockOutboundOrderStatisticsVo {
    return true;
}

export function KoreaStockOutboundOrderStatisticsVoFromJSON(json: any): KoreaStockOutboundOrderStatisticsVo {
    return KoreaStockOutboundOrderStatisticsVoFromJSONTyped(json, false);
}

export function KoreaStockOutboundOrderStatisticsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaStockOutboundOrderStatisticsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'totalOrderCount': json['totalOrderCount'] == null ? undefined : json['totalOrderCount'],
        'totalProcessingOrderCount': json['totalProcessingOrderCount'] == null ? undefined : json['totalProcessingOrderCount'],
        'totalOutboundOrderCount': json['totalOutboundOrderCount'] == null ? undefined : json['totalOutboundOrderCount'],
        'totalOutboundCancelOrderCount': json['totalOutboundCancelOrderCount'] == null ? undefined : json['totalOutboundCancelOrderCount'],
        'totalReturnOrderCount': json['totalReturnOrderCount'] == null ? undefined : json['totalReturnOrderCount'],
    };
}

export function KoreaStockOutboundOrderStatisticsVoToJSON(json: any): KoreaStockOutboundOrderStatisticsVo {
    return KoreaStockOutboundOrderStatisticsVoToJSONTyped(json, false);
}

export function KoreaStockOutboundOrderStatisticsVoToJSONTyped(value?: KoreaStockOutboundOrderStatisticsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalOrderCount': value['totalOrderCount'],
        'totalProcessingOrderCount': value['totalProcessingOrderCount'],
        'totalOutboundOrderCount': value['totalOutboundOrderCount'],
        'totalOutboundCancelOrderCount': value['totalOutboundCancelOrderCount'],
        'totalReturnOrderCount': value['totalReturnOrderCount'],
    };
}

